import { useEffect, useMemo, memo } from 'react';
import { useIdentityStore } from '@/stores/useIdentityStore';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Sparkles } from 'lucide-react';

export const IdentityVoteDisplay = memo(() => {
  const { identities, loadIdentities } = useIdentityStore();

  useEffect(() => {
    loadIdentities();
  }, [loadIdentities]);

  // ✅ FASE 9: Memoizar cálculo de total de votos
  const totalVotes = useMemo(() => 
    identities.reduce((sum, i) => sum + i.votesCast, 0),
    [identities]
  );

  if (identities.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg">
          <Sparkles className="w-5 h-5 text-primary" />
          Suas Identidades
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {identities.map((identity) => {
          const percentage = totalVotes > 0 ? (identity.votesCast / totalVotes) * 100 : 0;
          
          return (
            <div key={identity.id} className="space-y-2">
              <div className="flex items-center justify-between">
                <p className="font-medium text-sm">{identity.identityStatement}</p>
                <span className="text-xs text-muted-foreground">
                  {identity.votesCast} votos
                </span>
              </div>
              <Progress value={percentage} className="h-2" />
              {identity.pillar && (
                <p className="text-xs text-muted-foreground capitalize">
                  Pilar: {identity.pillar}
                </p>
              )}
            </div>
          );
        })}

        <div className="pt-4 border-t text-sm text-muted-foreground">
          <p>
            💡 Cada check-in de hábito é um voto para quem você está se tornando.
          </p>
        </div>
      </CardContent>
    </Card>
  );
});

IdentityVoteDisplay.displayName = 'IdentityVoteDisplay';
